
<template>
    <div class="video_box">
        <el-dialog :visible.sync="isShow" :before-close="handleClose" width="800px" >
          <video id="video" controls autoplay width="100%" :src="videoUrl"></video>
        </el-dialog>
    </div>
</template>
<script>
// import $ from "jquery"
export default {
    props: ["videoUrl"],
    data() {
        return {
            isShow:false,
        }
    },
    mounted() {
       
    },
    methods: {
        showDialog(){
            this.isShow = true;
            setTimeout(()=>{
                var video = $("#video")[0];
                if(video && video.paused){
                    video.play();
                }
            },0)
            
        },
        handleClose(done){
            this.isShow = false;
             setTimeout(()=>{
                var video = $("#video")[0];
                if(video && video.play){
                    video.pause();
                }
            },0)
        }
    }
}
</script>
<style lang="less" >
    .video_box{
        .el-dialog{
            background: #061335
        }
        .el-dialog__header{
            padding:0;
            .el-dialog__headerbtn{
                z-index: 3000;
            }
        }
        .el-dialog__body{
            padding:0;
            border-radius: 5px;
            overflow: hidden;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/videoDialog.vue